export default __webpack_public_path__ + "static/media/user-profile.ee02600a.png";